import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/home/Home";
import OurTeam from "../pages/our-team/OurTeam";
import TeamDetails from "../pages/TeamDetails";
import CurrentStudies from "../pages/current-studies/CurrentStudies";
import ScrollToTop from "./ScrollToTop";
import ContactUs from "../pages/contact-us/ContactUs";
import DiagnosticStudyIntake from "../pages/contact-us/DiagnosticStudyIntake";
import OurValues from "../pages/our-values/OurValues";
import NotFoundPage from "../pages/not-found/NotFoundPage";
import StudiesDetails from "../pages/studies-details/StudiesDetails";
import axiosClient from "../api/axios";
import OurPartners from "../pages/our-partners/OurPartners";
import AffiliationDetail from "../pages/our-partners/AffiliationDetail";

const AppRoutes = () => {
  const [information, setInformation] = useState(null);
  const [loadingInformation, setLoadingInformation] = useState(true);

  useEffect(() => {
    const fetchInformation = async () => {
      try {
        const response = await axiosClient.get(`/api/information/`);
        setInformation(response.data.data);
      } catch (error) {
        console.error("Failed to fetch study:", error);
      } finally {
        setLoadingInformation(false);
      }
    };

    fetchInformation();
  }, []);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home information={information} />} />

        <Route
          path="/current-studies"
          element={<CurrentStudies information={information} />}
        />
        <Route
          path="/current-studies/:id"
          element={<StudiesDetails information={information} />}
        />

        <Route
          path="/contact-us"
          element={<ContactUs information={information} />}
        />
        <Route
          path="/diagnostic-study-intake"
          element={<DiagnosticStudyIntake information={information} />}
        />
        <Route
          path="/our-values"
          element={<OurValues information={information} />}
        />

        <Route
          path="/our-team"
          element={<OurTeam information={information} />}
        />
        <Route
          path="/our-team/:id"
          element={<TeamDetails information={information} />}
        />

        <Route
          path="/our-partners"
          element={<OurPartners information={information} />}
        />
        <Route
          path="/our-partners/:slug"
          element={<AffiliationDetail information={information} />}
        />

        <Route path="*" element={<NotFoundPage information={information} />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
